
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { leadData } from "../FormData/CrmFormData";
import { Col, Label, FormGroup, Input } from "reactstrap";
import { Button } from "reactstrap";
import TextField from "../../../common/TextField";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import MobileField from "../../../common/MobileField";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { createCRMLeadService, getCrmDDLService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import DatePicker from "../../../common/DatePicker";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { H3 } from "../../../../AbstractElements";
import DollarInput from "../../../common/DollarInput";
import Dropdown from "../../../common/DropDown";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import SelectDatePicker from "../../../common/SelectDatePicker";
import { getAllStates, getAllAreas } from "../../../../Services/MMPClientServices/PropertySearchService";
import { getAllBuildersService } from "../../../../Services/CRMAdminServices/CRMBuildersService";
import { getAllStagesService } from "../../../../Services/CRMAdminServices/CRMStagesService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RootState } from '../../../../ReduxToolkit/Store';
import { useSelector } from "react-redux";
import DiscoveryCallLead from "./DiscoveryCallLead";

interface LeadCheckboxOption {
    name: string;
    label: string;
    tabIndex: number;
    value: string;
    backendField: string;
}

const leadCheckboxOptions: LeadCheckboxOption[] = [
    { name: "propertyTop3", label: "Property", tabIndex: 28, value: "Property Top 3", backendField: "state" },
    { name: "businessLoan", label: "Finance", tabIndex: 29, value: "Business Loan", backendField: "suburb" },
];

export default function AddLead() {
    const queryClient = useQueryClient();
    // const { RoleName, nameidentifier } = useSelector((state: RootState) => state.adminAuth);
//   const isAdmin = RoleName?.toLowerCase() === "admin";
   // const [formData, setFormData] = useState<any>(leadData);
   const [formData, setFormData] = useState<any>({
    ...leadData,
    // staff: isAdmin ? "" : nameidentifier || "", // Pre-set staff for non-Admins
  });
    const [formErrors, setFormErrors] = useState<any>({});
    const navigate = useSafeNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const isMMPAssetsLiabilitiesRoute = location.pathname === '/MMPAssetsLiabilities';
    const [leadDropdownData, setLeadDropdownData] = useState<any>([]);
    const [statesData, setStatesData] = useState<any>([]);
    const [areasData, setAreasData] = useState<any>([]);
    const [suburb, setSuburb] = useState<any[]>([]);
    const [buildersOptions, setBuildersOptions] = useState<any[]>([]);
    const [filteredAgents, setFilteredAgents] = useState<any[]>([]);
    const [stagesOptions, setStagesOptions] = useState<any[]>([]);
    // Add state for temporary agent emails
    const [agentEmails, setAgentEmails] = useState({
        realEstateAgent1Email: '',
        realEstateAgent2Email: '',
        realEstateAgent3Email: ''
    });

    // Debug useEffect to track agentEmails changes
    useEffect(() => {
        console.log('Agent emails state updated:', agentEmails);
    }, [agentEmails]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        console.log('handleValueChange called:', name, value);
        
        setFormData((prevData: any) => {
            const newData = {
                ...prevData,
                [name]: name === 'surname' ? (value as string)?.toUpperCase() : value,
                // staff: isAdmin ? prevData.staff : nameidentifier || "", // Lock staff for non-Admins
            };
            
            // If suburb is being changed, automatically set the postcode
            if (name === 'suburb' && value && typeof value === 'string') {
                // console.log('Suburb selected:', value, 'Type:', typeof value);
                // console.log('Available suburbs:', suburb);
                // console.log('Suburb data structure example:', suburb[0]);
                
                // Try different comparison methods
                const selectedSuburb = suburb.find((s: any) => {
                    // console.log('Comparing:', s.value, 'with', value, 'Types:', typeof s.value, typeof value);
                    return s.value === value || s.value === parseInt(value) || s.value === value.toString();
                });
                
                // console.log('Found selected suburb:', selectedSuburb);
                // console.log('Selected suburb keys:', selectedSuburb ? Object.keys(selectedSuburb) : 'No suburb found');
                
                if (selectedSuburb && selectedSuburb.postcode) {
                    console.log('Setting postcode to:', selectedSuburb.postcode);
                    newData.suburbdigit = selectedSuburb.postcode;
                } else {
                    // console.log('No postcode found for selected suburb');
                    // console.log('Selected suburb postcode field:', selectedSuburb?.postcode);
                    newData.suburbdigit = '';
                }
            }
            
            return newData;
        });
        
        // Handle agent email setting separately (not saved to formData)
        if ((name === 'realEstateAgent1' || name === 'realEstateAgent2' || name === 'realEstateAgent3') && value) {
            console.log('Agent selection detected:', name, 'Value:', value);
            console.log('Available filtered agents:', filteredAgents);
            
            const selectedAgent = filteredAgents.find((agent: any) => 
                agent.value === value || 
                agent.value === parseInt(value as string) || 
                agent.value === value.toString()
            );
            console.log('Selected agent found:', selectedAgent);
            
            if (selectedAgent && selectedAgent.email) {
                const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' : 
                                     name === 'realEstateAgent2' ? 'realEstateAgent2Email' : 
                                     'realEstateAgent3Email';
                console.log('Setting email for field:', emailFieldName, 'Email:', selectedAgent.email);
                setAgentEmails(prev => ({
                    ...prev,
                    [emailFieldName]: selectedAgent.email
                }));
            } else {
                // Clear email if no agent selected or no email found
                const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' : 
                                     name === 'realEstateAgent2' ? 'realEstateAgent2Email' : 
                                     'realEstateAgent3Email';
                console.log('Clearing email for field:', emailFieldName);
                setAgentEmails(prev => ({
                    ...prev,
                    [emailFieldName]: ''
                }));
            }
        } else if ((name === 'realEstateAgent1' || name === 'realEstateAgent2' || name === 'realEstateAgent3') && !value) {
            // Clear email when agent is deselected
            const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' : 
                                 name === 'realEstateAgent2' ? 'realEstateAgent2Email' : 
                                 'realEstateAgent3Email';
            console.log('Clearing email for field (no value):', emailFieldName);
            setAgentEmails(prev => ({
                ...prev,
                [emailFieldName]: ''
            }));
        }
        
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleCheckboxChange = (name: string) => {
        const optionValue = getCheckboxOption(name)?.value || "";
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: prevData[name] === optionValue ? "" : optionValue
        }));
    };

    const getCheckboxOption = (name: string) => {
        return leadCheckboxOptions.find(option => option.name === name);
    };

    const prepareLeadPayload = () => {
        const payload: any = { ...formData };
        leadCheckboxOptions.forEach(option => {
            payload[option.backendField] = formData[option.name] || "";
        });
        return payload;
    };

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    const {
        data: allStagesDataResponse,
        isLoading: stagesLoading,
        isError: stagesIsError,
    } = useGetRequestQuery<any>(
        ["getAllStagesService"],
        getAllStagesService,
        { enabled: true }
    );

    useEffect(() => {
        if (allStagesDataResponse && !stagesIsError && !stagesLoading) {
            const rawStages = Array.isArray(allStagesDataResponse?.data?.data)
                ? allStagesDataResponse.data.data
                : Array.isArray(allStagesDataResponse?.data)
                    ? allStagesDataResponse.data
                    : [];

            const transformedStages = rawStages
                .filter((stage: any) => !stage.isDeleted)
                .map((stage: any) => ({
                    value: stage.stageId.toString(),
                    label: stage.name,
                    orderBy: stage.orderBy
                }));

            const sorted = transformedStages.sort((a: any, b: any) => {
                const orderA = a.orderBy !== undefined && a.orderBy !== null ? Number(a.orderBy) : 999;
                const orderB = b.orderBy !== undefined && b.orderBy !== null ? Number(b.orderBy) : 999;
                return orderA - orderB;
            });

            setStagesOptions(sorted);
        }
    }, [allStagesDataResponse, stagesIsError, stagesLoading]);

    const {
        data: allStatesData,
        isLoading: allStatesLoading,
        isError: allStatesIsError,
    } = useGetRequestQuery(
        ["getAllStates"],
        getAllStates,
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (allStatesData?.data && !allStatesIsError && !allStatesLoading) {
            const transformedData = allStatesData.data.map((state: any) => ({
                value: state.id,
                label: state.name
            }));
            setStatesData(transformedData);
        }
    }, [allStatesData, allStatesIsError, allStatesLoading]);

    const {
        data: allAreasData,
        isLoading: allAreasLoading,
        isError: allAreasIsError,
    } = useGetRequestQuery(
        ["getAllAreas", formData.state],
        () => getAllAreas({
            searchId: formData.state,
            searchType: "area"
        }),
        {
            enabled: !!formData.state,
        }
    );

    useEffect(() => {
        if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
            const transformedData = allAreasData?.data?.map((area: any) => ({
                value: area.id,
                label: area.name
            }));
            setAreasData(transformedData);
        }
    }, [allAreasData, allAreasIsError, allAreasLoading]);

    const {
        data: allSuburbsData,
        isLoading: allSuburbsLoading,
        isError: allSuburbsIsError,
    } = useGetRequestQuery(
        ["getAllSuburbs", formData.area],
        () => getAllAreas({
            searchId: formData.area,
            searchType: "suburb"
        }),
        {
            enabled: !!formData.area,
        }
    );

    useEffect(() => {
        if (allSuburbsData?.data && !allSuburbsIsError && !allSuburbsLoading) {
            // console.log('Raw suburbs data from API:', allSuburbsData?.data);
            // console.log('First suburb example:', allSuburbsData?.data[0]);
            
            const transformedSuburbsData = allSuburbsData?.data?.map((suburb: any) => ({
                value: suburb.id,
                label: suburb.name,
                postcode: suburb.postcode
            }));
            
            // Sort suburbs alphabetically by label (name)
            const sortedSuburbsData = transformedSuburbsData.sort((a: any, b: any) => 
                a.label.localeCompare(b.label)
            );
            
            // console.log('Transformed suburbs data:', transformedSuburbsData);
            // console.log('First transformed suburb:', transformedSuburbsData[0]);
            
            setSuburb(sortedSuburbsData);
        }
    }, [allSuburbsData, allSuburbsIsError, allSuburbsLoading]);

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            const ddl = leadsDataDDL.data;
            const sortedDdl = { ...ddl };
            if (Array.isArray(sortedDdl.leadSources)) sortedDdl.leadSources.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            if (Array.isArray(sortedDdl.staff)) sortedDdl.staff.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            if (Array.isArray(sortedDdl.allStages)) sortedDdl.allStages.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            
            setLeadDropdownData(sortedDdl);
            
            const stageParam = searchParams.get('stage');
            if (stageParam) {
                setFormData((prev: typeof leadData) => ({
                    ...prev,
                    stage: stageParam
                }));
            }
        }
    }, [leadsDataDDL, searchParams]);

    // Set agent emails when form data is loaded with existing agent selections
    useEffect(() => {
        if (formData && filteredAgents.length > 0) {
            const newAgentEmails = {
                realEstateAgent1Email: '',
                realEstateAgent2Email: '',
                realEstateAgent3Email: ''
            };

            // Check for existing agent selections and set their emails
            if (formData.realEstateAgent1) {
                const agent1 = filteredAgents.find((agent: any) => 
                    agent.value === formData.realEstateAgent1 || 
                    agent.value === parseInt(formData.realEstateAgent1) || 
                    agent.value === formData.realEstateAgent1.toString()
                );
                if (agent1 && agent1.email) {
                    newAgentEmails.realEstateAgent1Email = agent1.email;
                }
            }

            if (formData.realEstateAgent2) {
                const agent2 = filteredAgents.find((agent: any) => 
                    agent.value === formData.realEstateAgent2 || 
                    agent.value === parseInt(formData.realEstateAgent2) || 
                    agent.value === formData.realEstateAgent2.toString()
                );
                if (agent2 && agent2.email) {
                    newAgentEmails.realEstateAgent2Email = agent2.email;
                }
            }

            if (formData.realEstateAgent3) {
                const agent3 = filteredAgents.find((agent: any) => 
                    agent.value === formData.realEstateAgent3 || 
                    agent.value === parseInt(formData.realEstateAgent3) || 
                    agent.value === formData.realEstateAgent3.toString()
                );
                if (agent3 && agent3.email) {
                    newAgentEmails.realEstateAgent3Email = agent3.email;
                }
            }

            console.log('Setting agent emails from existing form data:', newAgentEmails);
            setAgentEmails(newAgentEmails);
        }
    }, [formData, filteredAgents]);

    // Fetch builders data
    const {
        data: buildersData,
        isLoading: buildersLoading,
        isError: buildersIsError,
    } = useGetRequestQuery(
        ["getAllBuilders"],
        getAllBuildersService,
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (buildersData?.data && !buildersIsError && !buildersLoading) {
            const transformedData = buildersData.data.map((builder: any) => ({
                value: builder.supplierId,
                label: `${builder.supplier} - ${builder.bdmFirstName} ${builder.bdmLastName}`,
                areaId: builder.areaId,
                email: builder.bdmEmail
            }));
            console.log('Initial builders data:', buildersData?.data);
            console.log('Transformed builders data with emails:', transformedData);
            setBuildersOptions(transformedData);
            setFilteredAgents([]); // Initially show no agents
            console.log('Initial filtered agents set to empty');
        }
    }, [buildersData, buildersIsError, buildersLoading]);

    // Add new useEffect for area filtering
    useEffect(() => {
        // console.log('Area changed to:', formData.area);
        // console.log('Current builders options:', buildersOptions);
        
        if (formData.area && buildersOptions.length > 0) {
            // Filter agents that have matching areaId
            const filtered = buildersOptions.filter(agent => agent.areaId === parseInt(formData.area));
            // console.log('Filtered agents for area', formData.area, ':', filtered);
            setFilteredAgents(filtered);
        } else {
            // When no area is selected, show no agents
            // console.log('No area selected, setting filtered agents to empty');
            setFilteredAgents([]);
        }
    }, [formData.area, buildersOptions]);

    const {
        mutate: manageLead,
        isPending: isManageLeadPending,
    } = useMutationRequestQuery("manageLead", createCRMLeadService, {
        onSuccess: () => {
            toast.success("Lead added successfully.", { position: "bottom-center" });
            if (window.history.length > 2) {
                window.history.back();
            } else {
                navigate('/CRMTaskList');
            }
        },
        onError: () => {
            toast.error("Failed to add lead.", { position: "bottom-center" });
        },
    });

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const errors: any = {};
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const firstNameValue = formData.firstName?.trim() || "";
        const surnameValue = formData.surname?.trim() || "";
        const emailValue = formData.email?.trim() || "";
        const mobileValue = formData.mobile?.replace(/\s/g, "") || "";

        if (!firstNameValue) {
            errors.firstName = "First name is required.";
        }

        if (!surnameValue) {
            errors.surname = "Surname is required.";
        }

        if (!emailValue) {
            errors.email = "Email is required.";
        } else if (!emailPattern.test(emailValue)) {
            errors.email = "Please enter a valid email address!";
        }

        if (!mobileValue) {
            errors.mobile = "Mobile number is required.";
        }

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});
        const payload = prepareLeadPayload();
        payload.firstName = firstNameValue;
        payload.surname = surnameValue;
        payload.email = emailValue;
        manageLead(payload);
    };

    const propertyTop3Option = getCheckboxOption('propertyTop3');
    const businessLoanOption = getCheckboxOption('businessLoan');

    return (
        <>
            <div className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'}>
                <div className="table-responsive h-100 py-4">
                    <section className='bg-white'>

                        <div className="scrollable-table-container">
                            <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left my-2">Add Lead</H3>
                                    </Col>
                                </div>
                                <div className='d-flex item-center mt-2'>
                                    <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="mb-3">First Name:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <TextField
                                            label=""
                                            type="text"
                                            name="firstName"
                                            value={formData.firstName}
                                            setValue={handleValueChange}
                                            placeholder="First Name"
                                            design="flex"
                                            passCol="col-9"
                                            maxChars={20}
                                            tabIndex={1}
                                            required
                                            error={!!formErrors.firstName}
                                            errorMessage={formErrors.firstName || ""}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Source:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <DropdownWithValueName
                                            label=""
                                            name="source"
                                            value={formData.source}
                                            setValue={handleValueChange}
                                            options={leadDropdownData?.leadSources || []}
                                            passCol="col-9"
                                            design="flex"
                                            tabIndex={5}
                                        />
                                    </Col>


                                        <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '0px' }}>
                                        <FormGroup check className="mb-0">
                                            <Input
                                                type="checkbox"
                                                checked={!!formData.propertyTop3}
                                                onChange={() => handleCheckboxChange('propertyTop3')}
                                                tabIndex={propertyTop3Option?.tabIndex || 0}
                                            />
                                             <Label className="mb-3">Property</Label>
 
                                        </FormGroup>
                                    </Col>

                                    {/* <Col className="responsive-col" xs={12} style={{ width: '15%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Finance Approved</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <Dropdown
                                            label=""
                                            name="financeApproval"
                                            value={formData.financeApproval}
                                            setValue={handleValueChange}
                                            options={["No", "I have Lender Approval", "Mortgage Broker estimated", "Cash Buyer"]}
                                            passCol="col-9"
                                            design="flex"
                                            tabIndex={9}
                                        />
                                    </Col> */}
                                            {/* <Col className="responsive-col" xs={12} style={{ width: '12%', paddingInline: '2px' }}>
                                        <Label className="mb-3">House Value:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <DollarInput
                                            label=""
                                            name="houseValue"
                                            value={formData.houseValue}
                                            setValue={handleValueChange}
                                            passCol="col-9"
                                            design="flex"
                                            limit={8}
                                            tabIndex={10}
                                        />
                                    </Col> */}
                                </div>
                                <div className='d-flex item-center'>
                                    <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Surname:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <TextField
                                            label=""
                                            type="text"
                                            name="surname"
                                            value={formData.surname}
                                            setValue={handleValueChange}
                                            placeholder="Surname"
                                            design="flex"
                                            passCol="col-9"
                                            maxChars={20}
                                            tabIndex={2}
                                            required
                                            error={!!formErrors.surname}
                                            errorMessage={formErrors.surname || ""}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Staff:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <DropdownWithValueName
                                            label=""
                                            name="staff"
                                            value={formData.staff}
                                            setValue={handleValueChange}
                                            options={leadDropdownData?.staff || []}
                                            passCol="col-9"
                                            design="flex"
                                            tabIndex={6}
                                        />
                                    </Col>

                                       <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <FormGroup check className="mb-0">
                                            <Input
                                                type="checkbox"
                                                checked={!!formData.businessLoan}
                                                onChange={() => handleCheckboxChange('businessLoan')}
                                                tabIndex={businessLoanOption?.tabIndex || 0}
                                            />
                                                                                    <Label className="mb-3">Finance</Label>
 
                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </div>
                                <div className='d-flex item-center'>
                                    <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Email:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <TextField
                                            label=""
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            setValue={handleValueChange}
                                            placeholder="Email"
                                            design="flex"
                                            passCol="col-11"
                                            maxChars={40}
                                            tabIndex={3}
                                            required
                                            error={!!formErrors.email}
                                            errorMessage={formErrors.email || ""}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Stage:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <DropdownWithValueName
                                            label=""
                                            name="stage"
                                            value={formData.stage}
                                            setValue={handleValueChange}
                                            options={stagesOptions}
                                            passCol="col-9"
                                            design="flex"
                                            tabIndex={7}
                                            placeholder="Select"
                                        />
                                    </Col>
                                  
                                   
                                      
                                </div>
                                <div className='d-flex item-center'>
                                    <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Mobile:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <MobileField
                                            label=""
                                            mobileField="mobile"
                                            value={formData.mobile}
                                            setValue={(field, value) => handleValueChange(field, value)}
                                            placeholder="Mobile"
                                            design="flex"
                                            passCol="col-9"
                                            maxLength={14}
                                            tabIndex={4}
                                            required
                                            error={!!formErrors.mobile}
                                            errorMessage={formErrors.mobile || ""}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Label className="mb-3">Follow Up:</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <SelectDatePicker
                                            label=""
                                            name="followUp"
                                            value={formData.followUp}
                                            setValue={handleValueChange}
                                            passCol="col-9"
                                            design="flex"
                                            tabIndex={8}
                                        />
                                    </Col>
                                     {/* <Col className="responsive-col" xs={12} style={{ width: '12%', paddingInline: '2px' }}>
                                         <Label className="mb-3">Suburb:</Label>
                                     </Col>
                                     <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                         <DropdownWithValueName
                                             label=""
                                             name="suburb"
                                             value={formData.suburb}
                                             setValue={handleValueChange}
                                             options={suburb}
                                             passCol="col-9"
                                             design="flex"
                                             tabIndex={15}
                                         />
                                     </Col>
                              
                                     <Col className="responsive-col" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                         <TextField
                                             name="suburbdigit"
                                             value={formData.suburbdigit || ''}
                                             setValue={handleValueChange}
                                             type="number"
                                             maxChars={4}
                                             passCol="col-9"
                                             design="flex"
                                             tabIndex={16}
                                             disabled={true}
                                         />
                                     </Col>
                                     <Col className="responsive-col" xs={12} style={{ width: '15%', paddingInline: '2px' }}>
                                         <Label className="mb-3">Property Purpose ?</Label>
                                     </Col>
                                     <Col className="responsive-col" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                         <Dropdown
                                             label=""
                                             name="propertyPurpose"
                                             value={formData.propertyPurpose}
                                             setValue={handleValueChange}
                                             options={[
                                                 "New - Live In",
                                                 "New - Investment",
                                                 "Established - Live In",
                                                 "Established - Investment"
                                             ]}
                                             passCol="col-9"
                                             design="flex"
                                             tabIndex={12}
                                         />
                                     </Col> */}
                                </div>
                              
                                {/* <div className="d-flex item-center mt-2">
                                        <Col className="responsive-col" xs={2} style={{ paddingInline: '2px' }}>
                                            <Label className="mb-2 heading-color f-w-900" style={{ color: 'blue', cursor: 'pointer' }}>
                                                Property Address for sale
                                            </Label>
                                            </Col>
                                            <Col className="responsive-col" xs={10} style={{ paddingInline: '2px' }}>
                                            <TextField
                                                label=""
                                                name="propertyPurpose"
                                                value={formData.propertyPurpose}
                                                setValue={handleValueChange}
                                                type="text"
                                                maxChars={500}
                                                passCol="col-9"
                                                design="flex"
                                                tabIndex={17}
                                            />

                                            
                                             </Col>
                                    
                                    </div>
                             
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left my-2">Real Estate Agents</H3>
                                    </Col>
                                </div>
                                <div className='d-flex item-center mt-2'>
                                    <Col className="responsive-col" xs={12} style={{ width: '25%', paddingInline: '2px' }}>
                                        <Label className="mb-2 heading-color f-w-900">Real Estate Agent 1</Label>
                                        <DropdownWithValueName
                                            label=""
                                            name="realEstateAgent1"
                                            value={formData.realEstateAgent1}
                                            setValue={handleValueChange}
                                            options={filteredAgents}
                                            passCol="col-10"
                                            design="flex"
                                            tabIndex={22}
                                        />
                                        <TextField
                                            label=""
                                            type="email"
                                            name="realEstateAgent1Email"
                                            value={agentEmails.realEstateAgent1Email}
                                            setValue={handleValueChange}
                                            placeholder="Agent 1 Email"
                                            design="flex"
                                            passCol="col-10"
                                            maxChars={50}
                                            tabIndex={25}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '25%', paddingInline: '2px' }}>
                                        <Label className="mb-2 heading-color f-w-900">Real Estate Agent 2</Label>
                                        <DropdownWithValueName
                                            label=""
                                            name="realEstateAgent2"
                                            value={formData.realEstateAgent2}
                                            setValue={handleValueChange}
                                            options={filteredAgents}
                                            passCol="col-10"
                                            design="flex"
                                            tabIndex={23}
                                        />
                                        <TextField
                                            label=""
                                            type="email"
                                            name="realEstateAgent2Email"
                                            value={agentEmails.realEstateAgent2Email}
                                            setValue={handleValueChange}
                                            placeholder="Agent 2 Email"
                                            design="flex"
                                            passCol="col-10"
                                            maxChars={50}
                                            tabIndex={26}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '25%', paddingInline: '2px' }}>
                                        <Label className="mb-2 heading-color f-w-900">Real Estate Agent 3</Label>
                                        <DropdownWithValueName
                                            label=""
                                            name="realEstateAgent3"
                                            value={formData.realEstateAgent3}
                                            setValue={handleValueChange}
                                            options={filteredAgents}
                                            passCol="col-10"
                                            design="flex"
                                            tabIndex={24}
                                        />
                                        <TextField
                                            label=""
                                            type="email"
                                            name="realEstateAgent3Email"
                                            value={agentEmails.realEstateAgent3Email}
                                            setValue={handleValueChange}
                                            placeholder="Agent 3 Email"
                                            design="flex"
                                            passCol="col-10"
                                            maxChars={50}
                                            tabIndex={27}
                                            disabled={true}
                                        />
                                    </Col>
                                </div> */}


                                {/* <DiscoveryCallLead/> */}
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left my-2">Lead Comments</H3>
                                    </Col>
                                </div>
                                <Col className="responsive-col" xs={12} style={{ width: '85%', paddingInline: '2px' }}>
                                    <TextField
                                        label=""
                                        type="textarea"
                                        name="CommentText"
                                        value={formData.CommentText}
                                        setValue={handleValueChange}
                                        placeholder="Enter lead comments here..."
                                        design="default"
                                        rows={5}
                                        tabIndex={21}
                                        maxChars={500}
                                    />
                                </Col>
                            </table>

                            <div className="d-flex gap-3 py-3">
                                <Button
                                    onClick={() => navigate('/CRMTaskList')}
                                    color="secondary"
                                >
                                    Back to Leads
                                </Button>
                                <Button
                                    onClick={handleSubmit}
                                    color="primary"
                                    disabled={isManageLeadPending}
                                    type="submit"
                                >
                                    {isManageLeadPending ? "Loading . . ." : "Save Lead"}
                                </Button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}
